function initialValues({ accountId }) {
  return {
    nameOnCard: '',
    cardNumber: '',
    expirationDate: '',
    cvv: '',
    accountId,
    defaultCard: true,
    billingAddress: {
      accountId,
      address: '',
      address2: '',
      city: '',
      country: 'US',
      region: '',
      postalCode: '',
      isBilling: true,
    },
  };
}

export default initialValues;
